import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentStatus } from 'shared/api/tours/document-data'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import common from '../../styles.module.scss'

import { getStatusConfig } from './status-config'
import s from './styles.module.scss'

interface Props {
  status: TourDocumentStatus
}

const steps = [
  { icon: AllIcons.DOCUMENT, label: 'tourDetails.contractStep' },
  { icon: AllIcons.BOOKING, label: 'tourDetails.bookingStep' },
  { icon: AllIcons.PLANE_DEPARTURE, label: 'tourDetails.departureStep' },
]

export const BookingStatus: FC<Props> = ({ status }) => {
  const { t } = useTranslation()
  const config = getStatusConfig(status)

  return (
    <section className={clsx(common.card, s.card)}>
      <div>
        <h2 className="bold-16">{t('tourDetails.status')}</h2>
        <p className={clsx(common.caption, 'regular-14')}>{t(config.label)}</p>
      </div>
      <ol className={s.steps}>
        {steps.map((step, index) => (
          <li
            key={step.label}
            className={s[config.steps[index]]}
            aria-current={
              config.steps[index] === 'current' ? 'step' : undefined
            }
          >
            <span className={s.icon}>
              <AppIcon
                id={step.icon}
                width={18}
                height={18}
              />
            </span>
            <span className={clsx(s.label, 'medium-12')}>{t(step.label)}</span>
          </li>
        ))}
      </ol>
    </section>
  )
}
